import api from 'lib/api';


export const getAdminWorkbookList = (item) => {
    return api.post('/workbook/admin/workbook/list', item);
}

export const getAdminRegisterList = (item) => {
    return api.post('/workbook/admin/register/list', item);
}

export const getAdminFileList = (item) => {
    return api.post('/workbook/admin/file/list', item);
}

export const postAdminFileChange = (item) => {
    return api.post('/workbook/admin/file/change', item);
}

export const postAdminChangeTutorMemo = (item) => {
    return api.post('/workbook/admin/changeTutorMemo', item);
}